<template>
    <div :class="containerClasses">
      <CourseNode
        :node="coursePlan"
        :level="0"
        :collapsible="true"
      />
    </div>
  </template>
  
  <script lang="ts">
  import { Options, Vue } from 'vue-class-component';
  import { Prop } from '@/helpers/Decorators';
  import CourseNode from './CourseNode.vue';
  
  interface CourseNodeType {
    type: string;
    name: string;
    description: string;
    children?: CourseNodeType[];
  }
  
  @Options({
    name: 'CoursePlanVisualizer',
    components: {
      CourseNode
    }
  })
  export default class CoursePlanVisualizer extends Vue {
    @Prop({ type: Object, required: true })
    public coursePlan!: CourseNodeType;
  
    @Prop({ type: Boolean, default: false })
    public collapsible!: boolean;
  
    get containerClasses(): Record<string, boolean> {
      return {
        'course-plan-container': true,
        'collapsible': this.collapsible
      };
    }
  }
  </script>
  
  <style scoped>
  .course-plan-container {
    padding: 20px;
    font-family: Arial, sans-serif;
    background-color: #fafafa;
    border-radius: 8px;
  }
  
  .collapsible .node-header {
    cursor: pointer;
  }
  </style>
  